module.exports = "/assets/site/images/Hero.jpg?3d22ee3958d342881b12fbfb3819636b";